/** 新版首页路由（关闭 rem，使用 px 布局） */
export function isNewHomeRoute(path: string) {
  return /^\/(zh-CN|en-US)\/?$/.test(path)
}

export const HOME_REM_OFF_CLASS = 'home-rem-off'

/** 首屏同步脚本：在 Vue/rem 插件执行前为首页 html 打上 class，避免 .wrap padding 闪动 */
export const HOME_REM_EARLY_SCRIPT =
  `(function(){var p=location.pathname;if(/^\\/(zh-CN|en-US)\\/?$/.test(p))document.documentElement.classList.add('${HOME_REM_OFF_CLASS}');})();`
